export const COMMANDS = {
	PREVIOUS_PAGE: '1',
	REAL_TIME: '2',
	NEXT_PAGE: '3',
	DISPLAY_CUMULATIVE_RESULTS: '5',
	HIDE_RESULTS: '6',
	SHOW_HIDE_CHRONO: '7',
	SEATING_PLAN: '9',
	QUIT: '13',
	RESET_QUESTION_ANSWERS: '15',
	// Commandes non prises en compte
	NOT_VOTING: '22',
	DISPLAY_RANKING: '27',
	QR_CODE: '28',
};

export const COMMANDS_NAME = {
	SEATING_PLAN: 'PLAN_SALLE',
	PREVIOUS_PAGE: 'ACTION_PRECEDENTE',
	NEXT_PAGE: 'ACTION_SUIVANTE',
	REAL_TIME: 'AFFICHE_RESULTAT_QUESTION',
	HIDE_RESULTS: 'MASQUE_RESULTAT',
	DISPLAY_CUMULATIVE_RESULTS: 'AFFICHE_RESULTAT_CUMUL',
	RESET_QUESTION_ANSWERS: 'REINIT_REPONSE_QUESTION',
	QUIT: 'QUIT',
	SHOW_HIDE_CHRONO: 'SHOW_HIDE_CHRONO',
	NOT_VOTING: 'SHOW_HIDE_BAR_TELEC',
	DISPLAY_RANKING: 'AFFICHE_CLASSEMENT',
	QR_CODE: 'QR_CODE',
};
